import { render, staticRenderFns } from "./plistRecommend.vue?vue&type=template&id=78ae6c41&scoped=true&"
import script from "./plistRecommend.vue?vue&type=script&lang=js&"
export * from "./plistRecommend.vue?vue&type=script&lang=js&"
import style0 from "./plistRecommend.vue?vue&type=style&index=0&id=78ae6c41&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ae6c41",
  null
  
)

export default component.exports